import { render, staticRenderFns } from "./epb-keywords.component.vue?vue&type=template&id=4eb24c6e&scoped=true"
import script from "./epb-keywords.component.vue?vue&type=script&lang=ts"
export * from "./epb-keywords.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-keywords.component.vue?vue&type=style&index=0&id=4eb24c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb24c6e",
  null
  
)

export default component.exports